import * as angular from 'angular';

abstract class ComponentController implements angular.IComponentController {
  // stops accordion toggle from triggering when clicking "select" checkbox
  stopProp($event) {
    $event.stopPropagation();
  }

  deleteResource? = () => {};

  _confirmDelete = ($uibModal, resource, name) => {
    let modalInstance = $uibModal.open({
      animation: true,
      component: 'modalConfirm',
      size: 'small',
      resolve: {
        message: () => {
          return (
            'Are you sure you want to delete <strong>' +
            name +
            '</strong>? This action cannot be undone.'
          );
        },
        buttonText: () => {
          return 'Delete';
        },
        buttonClass: () => {
          return 'button-danger';
        },
        item: () => {
          return resource;
        }
      }
    });

    modalInstance.result.then(
      resource => {
        this.deleteResource();
      },
      () => {
        //user cancelled, do
      }
    );
  };
}

export default ComponentController;



// WEBPACK FOOTER //
// ./common/components/component-controller.ts